import { type Address } from '@webapp/models/Address'
import { ApiClient } from '@webapp/services/api'

export const ADDRESS_URL = '/api/v3/addresses'

export class AddressAPI {
  static readonly getAddresses = (params) =>
    ApiClient.get<{}, Address[]>(`${ADDRESS_URL}/`, {
      params: {
        ...params,
      },
    })

  static readonly getAddress = (addressId) =>
    ApiClient.get<{}, Address>(`${ADDRESS_URL}/${addressId}/`)

  static readonly getShippingAddresses = (params) =>
    ApiClient.get<{}, Address[]>(`${ADDRESS_URL}/shipping/`, {
      params: {
        ...params,
      },
    })

  static readonly getBillingAddresses = (params) =>
    ApiClient.get<{}, Address[]>(`${ADDRESS_URL}/billing/`, {
      params: {
        ...params,
      },
    })
}
